export default "__VITE_ASSET__BIbKB5DG__"